var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LineChart',{attrs:{"chartData":_vm.dataCollection,"chartId":_vm.chartName,"unit":_vm.measurementTypeUnit}})}
var staticRenderFns = []

export { render, staticRenderFns }